module Holidays
  ( Holiday
  , isHoliday
  , holidays
  ) where

import Prelude

import Data.Array as Array
import Data.Date (Date, Month(..), Year, canonicalDate, year)
import Data.Enum (toEnum)
import Data.Foldable (foldl)
import Data.Map (Map)
import Data.Map as Map
import Data.Maybe (Maybe(..))
import Data.Maybe as Maybe
import Data.Set (Set)
import Data.Set as Set
import Data.Tuple.Nested ((/\))

type Holiday =
  { name :: String
  , date :: Date
  }

year2022 :: Maybe Year
year2022 = toEnum 2022

year2023 :: Maybe Year
year2023 = toEnum 2023

year2024 :: Maybe Year
year2024 = toEnum 2024

year2025 :: Maybe Year
year2025 = toEnum 2025

year2026 :: Maybe Year
year2026 = toEnum 2026

holiday :: String -> Maybe Date -> Maybe Holiday
holiday name date = { name, date: _ } <$> date

holidays2022 :: Set Holiday
holidays2022 =
  Set.fromFoldable
    $ Array.catMaybes
        [ holiday "Confraternização Universal" $ canonicalDate <$> year2022 <*> Just January <*> (toEnum 1)
        , holiday "Dia de São Sebastião" $ canonicalDate <$> year2022 <*> Just January <*> (toEnum 20)
        , holiday "Carnaval" $ canonicalDate <$> year2022 <*> Just March <*> (toEnum 1)
        , holiday "Quarta-Feira de Cinzas" $ canonicalDate <$> year2022 <*> Just March <*> (toEnum 2)
        , holiday "Sexta-Feira da Paixão" $ canonicalDate <$> year2022 <*> Just April <*> (toEnum 15)
        , holiday "Tiradentes" $ canonicalDate <$> year2022 <*> Just April <*> (toEnum 21)
        , holiday "Dia de São Jorge" $ canonicalDate <$> year2022 <*> Just April <*> (toEnum 23)
        , holiday "Dia do Trabalhador" $ canonicalDate <$> year2022 <*> Just May <*> (toEnum 1)
        , holiday "Corpus Christi" $ canonicalDate <$> year2022 <*> Just June <*> (toEnum 16)
        , holiday "Independência do Brasil" $ canonicalDate <$> year2022 <*> Just September <*> (toEnum 7)
        , holiday "Dia de Nossa Senhora Aparecida" $ canonicalDate <$> year2022 <*> Just October <*> (toEnum 12)
        , holiday "Dia de Finados" $ canonicalDate <$> year2022 <*> Just November <*> (toEnum 2)
        , holiday "Proclamação da República" $ canonicalDate <$> year2022 <*> Just November <*> (toEnum 15)
        , holiday "Dia de Zumbi dos Palmares" $ canonicalDate <$> year2022 <*> Just November <*> (toEnum 20)
        , holiday "Véspera de Natal" $ canonicalDate <$> year2022 <*> Just December <*> (toEnum 24)
        , holiday "Natal" $ canonicalDate <$> year2022 <*> Just December <*> (toEnum 25)
        , holiday "Véspera de Ano Novo" $ canonicalDate <$> year2022 <*> Just December <*> (toEnum 30)
        , holiday "Ano Novo" $ canonicalDate <$> year2022 <*> Just December <*> (toEnum 31)
        ]

holidays2023 :: Set Holiday
holidays2023 =
  Set.fromFoldable
    $ Array.catMaybes
        [ holiday "Confraternização Universal" $ canonicalDate <$> year2023 <*> Just January <*> (toEnum 1)
        , holiday "Dia de São Sebastião" $ canonicalDate <$> year2023 <*> Just January <*> (toEnum 20)
        , holiday "Carnaval" $ canonicalDate <$> year2023 <*> Just February <*> (toEnum 20)
        , holiday "Carnaval" $ canonicalDate <$> year2023 <*> Just February <*> (toEnum 21)
        , holiday "Quarta-Feira de Cinzas" $ canonicalDate <$> year2023 <*> Just February <*> (toEnum 22)
        , holiday "Sexta-Feira da Paixão" $ canonicalDate <$> year2023 <*> Just April <*> (toEnum 7)
        , holiday "Tiradentes" $ canonicalDate <$> year2023 <*> Just April <*> (toEnum 21)
        , holiday "Dia de São Jorge" $ canonicalDate <$> year2023 <*> Just April <*> (toEnum 23)
        , holiday "Dia do Trabalhador" $ canonicalDate <$> year2023 <*> Just May <*> (toEnum 1)
        , holiday "Corpus Christi" $ canonicalDate <$> year2023 <*> Just June <*> (toEnum 8)
        , holiday "Independência do Brasil" $ canonicalDate <$> year2023 <*> Just September <*> (toEnum 7)
        , holiday "Dia de Nossa Senhora Aparecida" $ canonicalDate <$> year2023 <*> Just October <*> (toEnum 12)
        , holiday "Dia de Finados" $ canonicalDate <$> year2023 <*> Just November <*> (toEnum 2)
        , holiday "Proclamação da Repúbica" $ canonicalDate <$> year2023 <*> Just November <*> (toEnum 15)
        , holiday "Dia de Zumbi dos Palmares" $ canonicalDate <$> year2023 <*> Just November <*> (toEnum 20)
        , holiday "Natal" $ canonicalDate <$> year2023 <*> Just December <*> (toEnum 25)
        , holiday "Véspera de Ano Novo" $ canonicalDate <$> year2023 <*> Just December <*> (toEnum 31)
        ]

holidays2024 :: Set Holiday
holidays2024 =
  Set.fromFoldable
    $ Array.catMaybes
        [ holiday "Confraternização Universal" $ canonicalDate <$> year2024 <*> Just January <*> (toEnum 1)
        , holiday "Dia de São Sebastião" $ canonicalDate <$> year2024 <*> Just January <*> (toEnum 20)
        , holiday "Carnaval" $ canonicalDate <$> year2024 <*> Just February <*> (toEnum 12)
        , holiday "Carnaval" $ canonicalDate <$> year2024 <*> Just February <*> (toEnum 13)
        , holiday "Quarta-Feira de Cinzas" $ canonicalDate <$> year2024 <*> Just February <*> (toEnum 14)
        , holiday "Sexta-Feira da Paixão" $ canonicalDate <$> year2024 <*> Just March <*> (toEnum 29)
        , holiday "Tiradentes" $ canonicalDate <$> year2024 <*> Just April <*> (toEnum 21)
        , holiday "Dia de São Jorge" $ canonicalDate <$> year2024 <*> Just April <*> (toEnum 23)
        , holiday "Dia do Trabalhador" $ canonicalDate <$> year2024 <*> Just May <*> (toEnum 1)
        , holiday "Corpus Christi" $ canonicalDate <$> year2024 <*> Just May <*> (toEnum 30)
        , holiday "Independência do Brasil" $ canonicalDate <$> year2024 <*> Just September <*> (toEnum 7)
        , holiday "Dia de Nossa Senhora Aparecida" $ canonicalDate <$> year2024 <*> Just October <*> (toEnum 12)
        , holiday "Dia de Finados" $ canonicalDate <$> year2024 <*> Just November <*> (toEnum 2)
        , holiday "Proclamação da Repúbica" $ canonicalDate <$> year2024 <*> Just November <*> (toEnum 15)
        , holiday "Dia de Zumbi dos Palmares" $ canonicalDate <$> year2024 <*> Just November <*> (toEnum 20)
        , holiday "Natal" $ canonicalDate <$> year2024 <*> Just December <*> (toEnum 25)
        , holiday "Véspera de Ano Novo" $ canonicalDate <$> year2024 <*> Just December <*> (toEnum 31)
        ]

holidays2025 :: Set Holiday
holidays2025 =
  Set.fromFoldable
    $ Array.catMaybes
        [ holiday "Confraternização Universal" $ canonicalDate <$> year2025 <*> Just January <*> (toEnum 1)
        , holiday "Dia de São Sebastião" $ canonicalDate <$> year2025 <*> Just January <*> (toEnum 20)
        , holiday "Carnaval" $ canonicalDate <$> year2025 <*> Just March <*> (toEnum 3)
        , holiday "Carnaval" $ canonicalDate <$> year2025 <*> Just March <*> (toEnum 4)
        , holiday "Quarta-Feira de Cinzas" $ canonicalDate <$> year2025 <*> Just March <*> (toEnum 5)
        , holiday "Sexta-Feira da Paixão" $ canonicalDate <$> year2025 <*> Just April <*> (toEnum 18)
        , holiday "Tiradentes" $ canonicalDate <$> year2025 <*> Just April <*> (toEnum 21)
        , holiday "Dia de São Jorge" $ canonicalDate <$> year2025 <*> Just April <*> (toEnum 23)
        , holiday "Dia do Trabalhador" $ canonicalDate <$> year2025 <*> Just May <*> (toEnum 1)
        , holiday "Corpus Christi" $ canonicalDate <$> year2025 <*> Just June <*> (toEnum 19)
        , holiday "Independência do Brasil" $ canonicalDate <$> year2025 <*> Just September <*> (toEnum 7)
        , holiday "Dia de Nossa Senhora Aparecida" $ canonicalDate <$> year2025 <*> Just October <*> (toEnum 12)
        , holiday "Dia de Finados" $ canonicalDate <$> year2025 <*> Just November <*> (toEnum 2)
        , holiday "Proclamação da Repúbica" $ canonicalDate <$> year2025 <*> Just November <*> (toEnum 15)
        , holiday "Dia de Zumbi dos Palmares" $ canonicalDate <$> year2025 <*> Just November <*> (toEnum 20)
        , holiday "Natal" $ canonicalDate <$> year2025 <*> Just December <*> (toEnum 25)
        , holiday "Véspera de Ano Novo" $ canonicalDate <$> year2025 <*> Just December <*> (toEnum 31)
        ]

holidays2026 :: Set Holiday
holidays2026 =
  Set.fromFoldable
    $ Array.catMaybes
        [ holiday "Confraternização Universal" $ canonicalDate <$> year2026 <*> Just January <*> (toEnum 1)
        , holiday "Dia de São Sebastião" $ canonicalDate <$> year2026 <*> Just January <*> (toEnum 20)
        , holiday "Carnaval" $ canonicalDate <$> year2026 <*> Just February <*> (toEnum 16)
        , holiday "Carnaval" $ canonicalDate <$> year2026 <*> Just February <*> (toEnum 17)
        , holiday "Quarta-Feira de Cinzas" $ canonicalDate <$> year2026 <*> Just February <*> (toEnum 18)
        , holiday "Sexta-Feira da Paixão" $ canonicalDate <$> year2026 <*> Just April <*> (toEnum 3)
        , holiday "Tiradentes" $ canonicalDate <$> year2026 <*> Just April <*> (toEnum 21)
        , holiday "Dia de São Jorge" $ canonicalDate <$> year2026 <*> Just April <*> (toEnum 23)
        , holiday "Dia do Trabalhador" $ canonicalDate <$> year2026 <*> Just May <*> (toEnum 1)
        , holiday "Corpus Christi" $ canonicalDate <$> year2026 <*> Just June <*> (toEnum 6)
        , holiday "Independência do Brasil" $ canonicalDate <$> year2026 <*> Just September <*> (toEnum 7)
        , holiday "Dia de Nossa Senhora Aparecida" $ canonicalDate <$> year2026 <*> Just October <*> (toEnum 12)
        , holiday "Dia de Finados" $ canonicalDate <$> year2026 <*> Just November <*> (toEnum 2)
        , holiday "Proclamação da Repúbica" $ canonicalDate <$> year2026 <*> Just November <*> (toEnum 15)
        , holiday "Dia de Zumbi dos Palmares" $ canonicalDate <$> year2026 <*> Just November <*> (toEnum 20)
        , holiday "Natal" $ canonicalDate <$> year2026 <*> Just December <*> (toEnum 25)
        , holiday "Véspera de Ano Novo" $ canonicalDate <$> year2026 <*> Just December <*> (toEnum 31)
        ]

holidays :: Map Year (Map Date Holiday)
holidays =
  Array.catMaybes
    [ (/\) <$> year2022 <*> Just (asDateMap holidays2022)
    , (/\) <$> year2023 <*> Just (asDateMap holidays2023)
    , (/\) <$> year2024 <*> Just (asDateMap holidays2024)
    , (/\) <$> year2025 <*> Just (asDateMap holidays2025)
    , (/\) <$> year2026 <*> Just (asDateMap holidays2026)
    ]
    # Map.fromFoldable
  where

  asDateMap = foldl (\m h -> Map.insert h.date h m) Map.empty

isHoliday :: Date -> Boolean
isHoliday d = do
  let
    dYear = year d
  Map.lookup dYear holidays
    <#> Map.member d
    # Maybe.fromMaybe false
